import type { Context, RouteHistory } from './index.h'

import { MediaTypes } from '@setplex/tria-api'
import { STATIC_IDENTIFIERS } from '~/shared/appearance'
import { DEFAULT } from './index.h'

export const MODULE_NAMES_BY_IDENTIFIER = {
  [STATIC_IDENTIFIERS.HOME]: 'Home',
  [STATIC_IDENTIFIERS.TV]: 'TV',
  [STATIC_IDENTIFIERS.VOD]: 'Movies',
  [STATIC_IDENTIFIERS.SHOW]: 'TvShows',
  [STATIC_IDENTIFIERS.CATCHUP]: 'Catchups',
  [STATIC_IDENTIFIERS.EPG]: 'Epg',
  [STATIC_IDENTIFIERS.EVENT]: 'Events',
  [STATIC_IDENTIFIERS.SEARCH]: 'Search',
  [STATIC_IDENTIFIERS.LIBRARY]: 'My List',
}

export const MEDIA_TYPE_TO_ANALYTIX = {
  [MediaTypes.VOD]: 'Movies',
  [MediaTypes.TV_SHOW]: 'Series',
  [MediaTypes.TV_CHANNEL]: 'Live Channels',
  [MediaTypes.LIVE_EVENT]: 'Events',
}

/**
 * Mapping used when module identifier differs from analytics label.
 */
export const IDENTIFIER_TO_ANALYTIX = {
  'library': 'My List',
}

// Helper to get property by depth (1 = immediate parent, 3 = parent.parent.parent)
export function getPropertyByDepth(
  resolved: Context,
  depth: number,
  defaultValue: string
): string {
  let node = resolved
  for (let i = 0; i < depth; i++) {
    node = node?.parent
    if (!node) return defaultValue
  }
  return node?.path ? node.path : defaultValue
}

export function checkPropertyByDepth(
  resolved: Context,
  pathToCheck: string,
  maxDepth = 1
): boolean {
  let node = resolved
  for (let i = 0; i < maxDepth; i++) {
    node = node?.parent
    if (!node) return false
    if (node.path === pathToCheck) return true
  }
  return false
}

export const getPartsFromHistory = ({
  current,
  previous,
  beforePrevious,
  deep,
}): RouteHistory => {
  const module = current.module

  const resultModule = module
    ? (MODULE_NAMES_BY_IDENTIFIER[module] ?? module)
    : null

  if (!resultModule) return {}

  // use history of routes only across one module
  const beforePrev = deep > 2 ? beforePrevious : DEFAULT
  const prev = deep > 1 ? previous : DEFAULT
  const cur = current

  const routeName = cur.routeName || prev.routeName || beforePrev.routeName

  const categoryName =
    cur.categoryName || prev.categoryName || beforePrev.categoryName

  return {
    module: resultModule,
    routeName,
    categoryName,
  }
}

export const mergePartSToString = ({
  module,
  routeName,
  categoryName,
}: RouteHistory): string => {
  // user do not opened "/module" page before
  if (!module) return 'Direct link'

  let openedFrom = module

  if (!routeName && !categoryName) return openedFrom

  if (routeName) openedFrom = openedFrom + `/${routeName}`
  if (categoryName) openedFrom = openedFrom + `/${categoryName}`

  return openedFrom
}
